import classNames from "classnames";
import { useEffect, useRef } from "react";

import { Icon } from "src/app/components/icon/Icon";
import helpSrc from "src/assets/videos/help/kalkulatorTutorialFinal.mp4";

import helpCSS from "./Help.module.css";

const Help = ({ helpVideoModalActive, toggleHelpVideoModal }: { helpVideoModalActive: boolean; toggleHelpVideoModal: () => void }) => {
  const helpRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (helpVideoModalActive && helpRef && helpRef.current) {
      playVideo();
    }
  }, [helpVideoModalActive]);

  function playVideo() {
    helpRef.current?.play();
  }

  function stopVideo() {
    if (helpRef && helpRef.current) {
      helpRef.current.pause();
      helpRef.current.currentTime = 0;
    }
  }

  return (
    <div className={helpCSS.helpContainer}>
      <button onClick={toggleHelpVideoModal} className={classNames("u-cursor-pointer", helpCSS.helpButton)}>
        <Icon name="help" className="u-t-white" />
      </button>
      <div
        className={classNames(
          "u-pos-fixed",
          "u-z-index10",
          "u-w100",
          "u-h100 ",
          "u-bg-black",
          "u-bg-black-light",
          helpVideoModalActive ? "" : "u-none",
          helpCSS.videoContainer
        )}
      >
        <div className={classNames("u-pl20px", "u-pr20px", helpVideoModalActive ? "" : "u-none", helpCSS.videoContent)}>
          <button
            onClick={() => {
              toggleHelpVideoModal();
              stopVideo();
            }}
            className={classNames("u-t-white", "u-cursor-pointer", "u-pr20px", helpCSS.closeVideoButton)}
          >
            <Icon name={"close-modal"} className={helpCSS.closeModal} />
          </button>
          <video className={classNames(helpCSS.video, "u-align-self-center")} ref={helpRef} preload="true" loop={false} controls autoPlay={false}>
            <source src={helpSrc} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default Help;
